module.exports = __webpack_public_path__ + "img/Paymen-Completed-th.4edf594.png";